import { IconsProps } from '../icon-types';
import { SvgWrapper } from '../svg-wrapper/icon-wrapper';

export const BookmarkOutlineIcon = (props: IconsProps): React.ReactNode => (
  <SvgWrapper {...props}>
    <path
      d="M3.39999 3C3.39999 1.89543 4.29542 1 5.39999 1H18.6727C19.7773 1 20.6727 1.89543 20.6727 3V21.911C20.6727 23.1935 19.1677 23.8845 18.1951 23.0487L12.0364 17.756L5.87764 23.0487C4.90502 23.8845 3.39999 23.1935 3.39999 21.911V3ZM18.6727 3H5.39999V20.8221L11.3846 15.6791C11.7594 15.357 12.3133 15.357 12.6881 15.6791L18.6727 20.8221V3Z"
      fill="inherit"
      fillRule="evenodd"
    />
  </SvgWrapper>
);
